export const EUserSupportMessageTopic = {
  FOUND_A_BUG: 'FOUND_A_BUG',
  FEATURE_REQUEST: 'FEATURE_REQUEST',
  OTHER: 'OTHER',
};
